/**
 * @generated SignedSource<<e08557ab552bf44df293cd7626377d57>>
 * @relayHash 25cf59f5b03aae972cf632dae9685f3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFormEditRoutingQuery } from './uiFormEditRoutingQuery.graphql';

const node: PreloadableConcreteRequest<uiFormEditRoutingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3",
    "metadata": {},
    "name": "uiFormEditRoutingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
